import React, { useEffect, useState } from 'react';

const OutcomeDistributionChart = ({ data }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(false);
    const frame = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(frame);
  }, [data]);

  if (!data || data.length === 0) return null;

  const width = 120;
  const height = 120;
  const cx = width / 2;
  const cy = height / 2;
  const radius = 45;
  const strokeWidth = 15;
  const circumference = 2 * Math.PI * radius;

  const total = data.reduce((acc, curr) => acc + curr.value, 0);

  let currentOffset = 0;
  const circles = data.map((d) => {
    const strokeLength = total > 0 ? (d.value / total) * circumference : 0;
    const dasharray = `${strokeLength} ${circumference}`;
    const dashoffset = -currentOffset;
    currentOffset += strokeLength;
    return { ...d, dasharray, dashoffset };
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <circle cx={cx} cy={cy} r={radius} fill="none" stroke="var(--border)" strokeWidth={strokeWidth} />
        {total > 0 &&
          circles.map((c, i) => (
            <circle
              key={i}
              cx={cx}
              cy={cy}
              r={radius}
              fill="none"
              stroke={c.color}
              strokeWidth={strokeWidth}
              strokeDasharray={mounted ? c.dasharray : `0 ${circumference}`}
              strokeDashoffset={c.dashoffset}
              transform={`rotate(-90 ${cx} ${cy})`}
              className="insights-chart-donut-segment"
              style={{ transitionDelay: `${0.12 + i * 0.1}s` }}
            />
          ))}
      </svg>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {data.map((item, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: 'var(--c-black)' }}>
            <div style={{ width: '12px', height: '12px', borderRadius: '2px', background: item.color }} />
            {item.label} ({item.value})
          </div>
        ))}
      </div>
    </div>
  );
};

export default OutcomeDistributionChart;
